import React, { useEffect, useState } from "react";

import { Select } from "antd";
import { options } from "@fullcalendar/core/preact";
import { Any } from "react-spring";
import University1 from "./University1";
import { getcountries } from "../../HttpRequest/searchcalls";

const Country = ({ className, placeholder, userdata, setuserdata }) => {
  const [countryOptions, setCountryOptions] = useState();
  const [selectedCountry, setSelectedCountry] = useState();

  const onChange = (value) => {
    setSelectedCountry(value);
    setuserdata({
      country: value
    })
  };

  useEffect(() => {
    // if (userdata) {
    //   console.log("user data-->", userdata.country);
    //   if (userdata.country) {
    //     // setuserdata(userdata.country);
    //     setSelectedCountry(userdata.country);
    //   }
    // }
    getcountries().then((response) => {
      console.log('getcountries call')
      const filteredData = response.map(country => ({
        label: country.key,
        value: country.value,
      }));
      setCountryOptions(filteredData);
      console.log("filtered data", filteredData);
    });
  }, []);

  const onSearch = (value) => {
    console.log("search:", value);
  };
  // const handlechange = (value, option) => {
  //     // Use the selected value and option as needed
  //     console.log('Selected Value:', value);
  //     console.log('Selected Option:', option.label);

  //     // Update your state or perform other actions
  //     setcourseName((prevCourseName) => ({
  //       ...prevCourseName,
  //       course: value,
  //     }));
  //     localStorage.setItem("course", option.label)
  //   };

  const filterOption = (input, option) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());
  return (
    <>
      <Select
        showSearch
        bordered={false}
        placeholder={placeholder}
        optionFilterProp="children"
        className={className}
        onChange={onChange}
        onSearch={onSearch}
        filterOption={filterOption} style={{
          width: '200px',
          // width: "72%",
          border: "none",
          fontSize: "1.1rem",
          fontWeight: "500",
          boxShadow:'none'
        }}
        options={countryOptions}
        value={selectedCountry}
      />
      <University1 userdata={userdata} setuserdata={setuserdata} selectedCountry={selectedCountry} className={"cssfor"} placeholder={"Select University"} />
    </>
  );
};

export default Country;
